import React from "react";

/**
 * Primary + secondary CTAs (navigation callbacks from parent — no route logic here).
 */
export default function SuccessActions({ onLogin, onDashboard, onStartSelling }) {
  return (
    <nav className="success-reg-actions" aria-label="פעולות המשך">
      <button type="button" className="success-reg-actions__primary" onClick={onLogin}>
        כניסה למערכת
      </button>
      <div className="success-reg-actions__secondary-row">
        <button type="button" className="success-reg-actions__secondary" onClick={onDashboard}>
          מעבר לדשבורד
        </button>
        <button type="button" className="success-reg-actions__secondary" onClick={onStartSelling}>
          התחל למכור
        </button>
      </div>
    </nav>
  );
}
